/*
 * "Works for" — the democratization statement.
 *
 * Structure and effect copied faithfully from codepen.io/yemon/pen/YrPmQr
 * ("UX works for Developers / Designers / Coders / EVERYONE!"). The demo
 * styles <body> directly; here those properties live on the
 * .works-for__stage div, and the words roll via the original roll/roll2
 * keyframes in sections.css.
 *
 * One necessary deviation: the original loops 4 words over 5s with 1s
 * staggers. Sixteen words need sixteen 1s slots before the loop wraps,
 * so all durations are 18s instead of 5s.
 */

/* Audiences and tasks interleaved, closing on the inclusive punchline.
 * The stagger is 1s per word, so each entry adds 1s to the loop — keep
 * the CSS durations in sync when editing the word list. The list itself
 * lives in the content dictionaries (exactly sixteen words, enforced by
 * the WorksForWords tuple type). */

import type { WorksForContent } from "../i18n/types";

export function renderWorksFor(t: WorksForContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section works-for";
  root.id = "works-for";
  root.innerHTML = `
    <div class="works-for__stage">
      ${t.leadIn}
      <div class="dropping-texts">
        ${t.words.map((word) => `<div>${word}</div>`).join("")}
      </div>
    </div>
  `;
  return root;
}
